import { useState } from "react";
import { Dialog, DialogPanel } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import Hero from "../components/about/Hero";
import Timeline from "../components/about/Timeline";
import SeeUsInAction from "../components/about/SeeUsInAction";
import StorageFeatures from "../components/storage/StorageFeatures";

export default function Storage() {
  return (
    <div>
      <StorageFeatures />
    </div>
  );
}
